import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('sephirothMailAssoc');
export const actions = helper.createActions('sephirothMailAssoc', actionTypes);

